const ThemeToggle = ({ theme, onToggle, className = "" }) => {
  const isDark = theme === "dark";
  const label = isDark ? "Switch to light theme" : "Switch to dark theme";
  const title = isDark ? "Light mode" : "Dark mode";
  return (
    <button
      type="button"
      className={`nav__theme ${className}`.trim()}
      onClick={onToggle}
      aria-label={label}
      title={title}
    >
      <i className={isDark ? "fa-solid fa-sun" : "fa-solid fa-moon"} />
    </button>
  );
};

export default ThemeToggle;
